import React, { useEffect, useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { Modal, Button } from "react-bootstrap";
import "../../admin/pages/styles/usertable.css"
import Layout from "../../components/layout/Layout";

export default function UsersPage() {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await axios.get("https://data.shreemwell.in/api/auth/profiles");

      const filteredUsers = res.data.users.filter(
        (item) => item.role === "user"
      );

      setUsers(filteredUsers);
    } catch (err) {
      console.log(err);
    }
  };

  const handleView = (user) => {
    setSelectedUser(user);
    setShow(true);
  };

  const handleDelete = (id) => {
    if (!window.confirm("Are you sure?")) return;
    setUsers(users.filter((user) => user._id !== id));
  };

  return (
    <>
    <Layout>
    <div className="container mt-4">
      <h2 className="text-center mb-4 fw-bold">Users Table</h2>

      {/* ================= TABLE ================= */}
      <div className="table-responsive">
        <table className="table table-bordered table-hover text-center align-middle">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Company</th>
              <th>Level</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {users.length > 0 ? (
              users.map((user, index) => (
                <tr key={user._id}>
                  <td>{index + 1}</td>
                  <td>{user.name || "N/A"}</td>
                  <td>{user.email || "N/A"}</td>
                  <td>{user.phone || "N/A"}</td>
                  <td>{user.companyName || "N/A"}</td>
                  <td>{user.currentLevel || "N/A"}</td>

                 

                  <td>
                    <button
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => handleView(user)}
                    >
                      View
                    </button>

                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDelete(user._id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8">No Users Found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ================= MODAL ================= */}
      <Modal show={show} onHide={() => setShow(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>User Details</Modal.Title>
        </Modal.Header>

   <Modal.Body>
  {selectedUser && (
    <div className="container-fluid">

      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-3 p-3 bg-dark text-white rounded">
        <div>
          <h5 className="mb-0">{selectedUser.name || "N/A"}</h5>
          <small>{selectedUser.email || "N/A"}</small>
        </div>

        <span
          className={`badge px-3 py-2 ${
            selectedUser.isVerified ? "bg-success" : "bg-secondary"
          }`}
        >
          {selectedUser.isVerified ? "Verified" : "Not Verified"}
        </span>
      </div>

      {/* USER INFO TABLE */}
      <div className="table-responsive mb-4">
        <table className="table table-bordered align-middle">
         <tbody>
  <tr>
    
    <th>Phone</th>
    <td>{selectedUser.phone || "N/A"}</td>
    <th>WhatsApp</th>
    <td>{selectedUser.whatsapp || "N/A"}</td>
  </tr>

  <tr>
    
     <th>Company Name</th>
    <td>{selectedUser.companyName || "N/A"}</td>
  <th>Current Level</th>
    <td>Level {selectedUser.currentLevel || "N/A"}</td>
   
  </tr>



  <tr>
   
    <th>Upcoming Level</th>
    <td>{selectedUser.upcomingLevel || "N/A"}</td>
    <th>Current Location</th>
    <td>{selectedUser.currentLocation || "N/A"}</td>
  </tr>



 

  <tr>
    <th>Service Location</th>
    <td>{selectedUser.serviceLocation?.join(", ") || "N/A"}</td>
    <th>Which Location</th>
    <td>{selectedUser.whichLocation?.join(", ") || "N/A"}</td>
  </tr>

  <tr>
    <th>Team Size</th>
    <td>{selectedUser.teamSize ?? 0}</td>
    <th>Total Active</th>
    <td>{selectedUser.totalActive ?? 0}</td>
  </tr>

  <tr>
    <th>Total Inactive</th>
    <td>{selectedUser.totalInactive ?? 0}</td>
   
  </tr>

</tbody>
        </table>
      </div>

      {/* TEAM MEMBERS */}
     <div className="section-card">
  <h6 className="mb-3">Team Members</h6>

  {selectedUser.teamMembers?.length > 0 ? (
    selectedUser.teamMembers.map((member, i) => (
     <div key={i} className="team-form-card shadow-sm p-3 mb-4 bg-white rounded">

  {/* HEADER */}
  <div className="d-flex align-items-center mb-3 border-bottom pb-2">
    <img
      src={member.photo || "https://via.placeholder.com/60"}
      alt=""
      className="team-img me-3"
    />
    <div>
      <h6 className="mb-0 fw-bold">{member.name || "N/A"}</h6>
      <small className="text-muted">{member.email || "N/A"}</small>
    </div>
  </div>

  {/* BASIC DETAILS */}
  <h6 className="text-primary mb-2">Basic Details</h6>
  <div className="row g-2 mb-3">
    <div className="col-md-4">
      <label>Mobile</label>
      <div className="form-box">{member.mobile || "N/A"}</div>
    </div>
    <div className="col-md-4">
      <label>WhatsApp</label>
      <div className="form-box">{member.whatsapp || "N/A"}</div>
    </div>
    <div className="col-md-4">
      <label>Company</label>
      <div className="form-box">{member.companyName || "N/A"}</div>
    </div>

     <div className="col-md-4">
      <label>Companycode </label>
      <div className="form-box">{member.compCode || "N/A"}</div>
    </div>
    <div className="col-md-4">
      <label>DOB</label>
      <div className="form-box">
        {member.dob ? new Date(member.dob).toLocaleDateString() : "N/A"}
      </div>
    </div>
  </div>

  {/* LOCATION DETAILS */}
  <h6 className="text-success mb-2">Location Details</h6>
  <div className="row g-2 mb-3">
    <div className="col-md-4">
      <label>Current Location</label>
      <div className="form-box">{member.currentLocation || "N/A"}</div>
    </div>
    <div className="col-md-4">
      <label>Service Location</label>
      <div className="form-box">
        {member.serviceLocation?.join(", ") || "N/A"}
      </div>
    </div>
    <div className="col-md-4">
      <label>Which Location</label>
      <div className="form-box">
        {member.whichLocation?.join(", ") || "N/A"}
      </div>
    </div>
  </div>

  {/* HIERARCHY DETAILS */}
  <h6 className="text-warning mb-2">Hierarchy Details</h6>
  <div className="row g-2 mb-3">
    <div className="col-md-4">
      <label>Current Level</label>
      <div className="form-box">{member.currentLevel || "N/A"}</div>
    </div>
    <div className="col-md-4">
      <label>Upcoming Level</label>
      <div className="form-box">{member.upcomingLevel || "N/A"}</div>
    </div>
    <div className="col-md-4">
      <label>Upline</label>
      <div className="form-box">{member.upline || "N/A"}</div>
    </div>
    <div className="col-md-4">
      <label>Upline Name</label>
      <div className="form-box">{member.uplineName || "N/A"}</div>
    </div>
    <div className="col-md-4">
      <label>Upline Code</label>
      <div className="form-box">{member.uplineCode || "N/A"}</div>
    </div>
  </div>

  {/* ADDITIONAL DETAILS */}
  <h6 className="text-danger mb-2">Additional Details</h6>
  <div className="row g-2">
    <div className="col-md-6">
      <label>SAO Name</label>
      <div className="form-box">{member.saoName || "N/A"}</div>
    </div>
    <div className="col-md-6">
      <label>SAO Code</label>
      <div className="form-box">{member.saoCode || "N/A"}</div>
    </div>
    <div className="col-md-6">
      <label>SGO Name</label>
      <div className="form-box">{member.sgoName || "N/A"}</div>
    </div>
    <div className="col-md-6">
      <label>SGO Code</label>
      <div className="form-box">{member.sgoCode || "N/A"}</div>
    </div>
    <div className="col-md-6">
      <label>Referred By</label>
      <div className="form-box">{member.referredBy || "N/A"}</div>
      </div>
      <div className="col-md-6">
        <label>Comapny code </label>
      <div className="form-box">{member.referenceCode || "N/A"}</div>
    </div>
  </div>

</div>
    ))
  ) : (
    <p>No team members</p>
  )}
</div>
    </div>
  )}
</Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
    </Layout>
    </>
  );
}